<div class="token-expired">
  <app-dialog-common>
    <div class="content">
      <div class="token-expired__container">
        <div class="token-expired__container__image">
          <img
            alt="token-expired"
            class="token-expired__container__image"
            [src]="reTest"
          />
        </div>

        <div class="token-expired__container__title">{{ 'QIMA-LABS.TOKEN_CHECKER.TITLE' | translate }}</div>
        <div class="token-expired__container__description">
          <span [innerHTML]="'QIMA-LABS.TOKEN_CHECKER.CONTENT_SUB_TITLE' | translate"></span>
          <span [innerHTML]="'QIMA-LABS.TOKEN_CHECKER.CONTENT' | translate"></span>
        </div>
        <div class="token-expired__container__operation">
          <div class="btn_container">
            <qima-button
              [qimaButtonLabel]="'QIMA-LABS.TOKEN_CHECKER.CONFIRM_TEXT' | translate"
              (qimaButtonClick)="onLoginClick()"
              [qimaButtonStyle]="qimaButton.buttonStyle.PRIMARY"
              [qimaButtonSize]="qimaButton.buttonSize.LARGE"
              [qimaButtonWidth]="qimaButton.buttonWidth.FULL"
            ></qima-button>
          </div>
          <div class="btn_container">
            <qima-button
              [qimaButtonLabel]="'QIMA-LABS.TOKEN_CHECKER.CANCEL_TEXT' | translate"
              (qimaButtonClick)="onCloseClick()"
              [qimaButtonStyle]="qimaButton.buttonStyle.SECONDARY"
              [qimaButtonSize]="qimaButton.buttonSize.LARGE"
              [qimaButtonWidth]="qimaButton.buttonWidth.FULL"
            ></qima-button>
          </div>
        </div>
      </div>
    </div>
  </app-dialog-common>
</div>
